module.exports = __webpack_public_path__ + "images/aca4f0bb9c43697547093bf961313ba3.jpg";